import React from "react";
import SubscriptionError from "../../subscribe/subscription-error";
import SubscriptionSuccess from "../../subscribe/subscription-success";
var CodeRedeemResult = function CodeRedeemResult(_ref) {
    var subscriptionResult = _ref.subscriptionResult;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, subscriptionResult ? /*#__PURE__*/ React.createElement(SubscriptionSuccess, {
        result: subscriptionResult
    }) : /*#__PURE__*/ React.createElement(SubscriptionError, null));
};
export default CodeRedeemResult;
